import { type FirebaseOptions } from "firebase/app";

export type GoogleMapsConfig = {
  apiKey: string;
};

export type IngredifindConfig = {
  googleMaps: GoogleMapsConfig;
  firebase: FirebaseOptions;
  apiBaseUrl: string;
  supportPageUrl: string;
};

export const config = {
  googleMaps: {
    apiKey: "AIzaSyB7ULn20EYvboiQHZu6frkCk7fRxnzt-pU",
  },
  firebase: {
    apiKey: "AIzaSyDTLcFKeuTb0TwfOzpHmC1bXn5tnV0Hkxs",
    authDomain: "igfd-mobile.firebaseapp.com",
    projectId: "igfd-mobile",
    storageBucket: "igfd-mobile.appspot.com",
    messagingSenderId: "65313590455",
    appId: "1:65313590455:web:79ac13f1549262c5c4d132",
    measurementId: "G-C25KT8W41L",
  },
  apiBaseUrl: "https://gateway.ingredifind.com",
  supportPageUrl:
    "https://ingredifind.notion.site/Ingredifind-Support-Center-9ddc99e3dccd4dd7ab77f88ec26bce02",
} as IngredifindConfig;
